"use client";

import React from "react";

export const WesternProcessor = () => {
  return (
    <section className="w-full bg-black text-white py-12 sm:py-[70px] px-4">
      <div className="max-w-[1237px] mx-auto text-center">
        {/* Top Content */}
        <div
          className="inline-block
  px-4 py-1.5
  rounded-full
  text-sm text-white
  text-center mx-auto
  bg-[linear-gradient(85.07deg,#155dfc_-17.23%,rgba(20,34,77,0.17)_80.28%)]
  font-inter
  border border-[#2a2f3a]
  backdrop-blur-[32px] mb-[16px]"
        >
          Here's Why You're Exposed
        </div>
        <div className="flex flex-col gap-[42px]">
          {/* Left */}
          <div className="w-full">
            {/* <h2
              className="text-3xl text-center text-white md:text-[41px] font-inter mt-[16] leading-[110%] font-[400] "
            >
              Stripe, Standard PayPal &{" "} <br/>
              <span className=" ">
                Western Processors Were
              </span>
              <br/>
            </h2>
            <h2 className="font-normal leading-[110%] text-center text-3xl md:text-[41px] bg-[radial-gradient(circle_at_25%_0%,#6fa6ff_0%,#EDEFFF_40%,#FFFFFF_100%)] bg-clip-text text-transparent">
              Never Built for Scaling <br/>eCommerce
            </h2> */}
            <div className="text-center [font-family:'SharpGroteskPeTrialSmBold-15',sans-serif] lg:text-[70px] text-[32px] leading-[120%] font-normal">
              <span className="text-white">
                Stripe, Standard PayPal &<br className="sm:block hidden"/>
                Western Processors Were
                <br />
              </span>

              <span className="bg-[radial-gradient(closest-side,#6fa6ff_0%,rgba(255,255,255,1)_100%),linear-gradient(to_left,#c5c8da,#c5c8da)] bg-clip-text text-transparent">
                Never Built for Scaling
                <br className="sm:block hidden"/>
                eCommerce
              </span>
            </div>
          </div>

          {/* Right */}
          <div>
            <p className="text-[#a0a4b3] font-inter text-center max-w-[999px] mx-auto mb-[48px] font-[300] text-base md:text-[18px] ">
              They were built for SaaS companies charging $49/month with
              near-zero chargebacks. The moment you start scaling — running
              aggressive offers, doing high volume, processing internationally —
              you become a liability to them. Their risk model literally
              classifies you the same way they classify fraud.
            </p>
          </div>
        </div>

        {/* Table */}
        <div className="w-full">
          <div>
            <div className="relative rounded-3xl overflow-hidden border border-[#2a2f3a] bg-gradient-to-br from-[#1a1a2e] to-[#rgba(0, 166, 62, 0.00)]">
              {/* Glow */
              /*bg-[radial-gradient(circle_at_left,rgba(51,92,255,0.15),transparent_40%),radial-gradient(circle_at_right,rgba(208,50,50,0.30),transparent_20%) */}
              <div
                className="absolute inset-0 pointer-events-none"/>
              <div className="absolute right-[-319px] bottom-[-42.764px] w-[300px] h-[399px] bg-[#c44b4b] blur-[97px]"></div>
              {/* Table Content */}
              <div className="relative z-10">
  {/* Header */}
  <div className="grid md:grid-cols-[1fr_1fr_1fr] grid-cols-[0.6fr_1fr_1fr] border-b border-[#2a2f3a]">
    <div className="p-5 text-white text-[12px] md:text-[24px] text-left">
      Feature
    </div>
    <div className="p-5 text-[#00A63E] md:text-[24px] text-[12px] font-medium border-x border-[#2a2f3a] text-left">
      MuteTaxes HK Setup
    </div>
    <div className="p-5 text-[#FF6067] font-medium md:text-[24px] text-[12px] text-left">
      Standard Processors
    </div>
  </div>

  {/* Rows */}
  {[
    {
      title: "Account Stability",
      good: "Rock-solid. 8+ years. Zero bans.",
      bad: "Random bans with zero warning",
    },
    {
      title: "Fund Freezes",
      good: "Funds hit your account like clockwork",
      bad: "90–180 day holds, no recourse",
    },
    {
      title: "Scaling Limits",
      good: "Built to process $1M+/month",
      bad: "Flagged the moment you grow",
    },
    {
      title: "PayPal Access",
      good: "Verified HK Business PayPal the most stable tier on the planet",
      bad: "Weak. Personal. Easily limited.",
    },
    {
      title: "Tax Efficiency",
      good: "8.25% HK corporate rate — legally optimized",
      bad: "Full domestic tax exposure",
    },
  ].map((row, i) => (
    <div
      key={i}
      className="grid md:grid-cols-[1fr_1fr_1fr] grid-cols-[0.6fr_1fr_1fr] border-b last:border-none border-[#2a2f3a]"
    >
      {/* Feature */}
      <div className="md:p-5 p-2 md:text-[20px] text-[10px] font-normal text-left">
        {row.title}
      </div>

      {/* Good */}
      <div className="md:p-5 p-2 flex items-center gap-3 text-gray-200 border-x border-[#2a2f3a]">
        <span className="w-5 h-5 shrink-0 flex items-center justify-center rounded-full bg-green-500 text-black text-xs">
          ✔
        </span>
        <p className="lg:text-[14px] text-[12px] font-[300] text-left">
          {row.good}
        </p>
      </div>

      {/* Bad */}
      <div className="md:p-5 p-2 flex items-center gap-3 text-[14px]">
        <span className="w-5 h-5 shrink-0 flex items-center justify-center rounded-full bg-red-500 text-white text-xs">
          ✕
        </span>
        <p className="lg:text-[14px] text-[12px] font-[300] text-left text-white">
          {row.bad}
        </p>
      </div>
    </div>
  ))}
</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
